// import logo from './logo.svg'
import React, { Component, Fragment } from "react";
import { Route, BrowserRouter as Router, Switch, Redirect } from "react-router-dom";

import { addPushWebToken, getRoutes, getSetting } from "./actions/Utils";
import "./App.css";
import Footer from "./components/common/Footer";
import CommonHeader from "./components/common/header/Commonheader";
import PhotoGallery from "./components/gallery/PhotoGallery";
import VideoGallery from "./components/gallery/VideoGallery";

import Member from "./layout/MemberLayout";

import { base_path } from "./config/Api";
import HomeLayout from "./layout/Home";
// import Login from './layout/Login';
import OfficeBranch from "./components/branch/Branch";
import PolicyBuy from "./components/customer/PolicyBuy";
import ProductDetails from "./components/product/ProductDetails";
import Login from "./components/register/Login";
import SignupPolicy from "./components/register/SignupPolicy";

import NewsLayout from "./layout/News";
import PageLayout from "./layout/Page";
import PremiumCalculator from "./layout/PremiumCalculator";
import Register from "./layout/Register";
import RegisterOffice from "./layout/RegisterOffice";
import LoginOffice from "./layout/LoginOffice";
import RegisterCustomer from "./layout/RegisterCustomer";
import LoginCustomer from "./layout/LoginCustomer";
import RegisterEmployee from "./layout/RegisterEmployee";
import LoginEmployee from "./layout/LoginEmployee";
import ForgotPasswordNew from "./layout/ForgotPasswordNew";
import MicrositeProgress from "./layout/MicrositeProgress";
import SearchLayout from "./layout/SearchLayout";
import CommonLanding from "./page/CommonLanding";


// Publication component end
import configureStore from "./store/Configurstore";

import ForgotPassword from "./layout/ForgotPassword";
// import ResetPassword from "./layout/ResetPassword";

// import firebase from './config/Firebase';
// import { getMessaging, getToken } from "firebase/messaging";

// import firebase from 'firebase/compat/app';
// import { getMessaging, getToken ,onMessage} from "firebase/messaging";

// import Notifications from './components/Notifications/Notifications';

import Htmlhelmet from "./components/common/HtmlHelmet";
import Paydirectstepfour from "./components/paydirect/Paydirectstepfour";
import Paydirectstepone from "./components/paydirect/Paydirectstepone";
import Paydirectstepthree from "./components/paydirect/Paydirectstepthree";
import Paydirectsteptwo from "./components/paydirect/Paydirectsteptwo";

// web user panel
import ChangePassword from "./components/webuserpanel/ChangePassword";
import Dashboard from "./components/webuserpanel/Dashboard";
import PaymentInvoice from "./components/webuserpanel/PaymentInvoice";
import PolicyDetails from "./components/webuserpanel/PolicyDetails";
import ReturnCalculator from "./layout/ReturnCalculator";
import DashboardDemo from "./components/dashboard/Dashboard";
import { Toaster } from "react-hot-toast";
import SampleLogin from "./components/register/SampleLogin";
import PolicyFormPreview from "./components/customer/PolicyFormPreview";
import ResetPassword from "./components/ResetPassword/ResetPassword";
import Profile from "./components/profile/Profile";
import ProtectedRoute from "./components/protectedRoute/ProtectedRoute";
import PublicRoute from "./components/protectedRoute/PublicRoute";
import PolicyFormPreviewCustomer from "./components/customer/PolicyFormPreviewCustomer";
// import SuccessPage from "./components/customer/Success";
// import FailPage from "./components/customer/Fail";
// import PolicyList from "./components/CustomerPolicyList/PolicyList";
import "./Styles/custom_rz.scss";
const { store } = configureStore();

console.log(store);

// const messagingab = getMessaging()
// onMessage(messagingab, (payload) => {
//   console.log("message firebsae payload",payload);
// })

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error", error, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "50px", textAlign: "center", color: "red" }}>
          <h1>Something went wrong.</h1>
          <pre>{this.state.error && this.state.error.toString()}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      utils: store.getState().utils,
      routemenu: store.getState().utils.routemenu,
      pubroutemenu: store.getState().utils.pubroutemenu,
      notificaitonshow: false,
      notification: {
        title: "",
        body: "",
      },
    };
  }

  handlePushNotification = (token) => {
    var requestData = {
      device_id: token,
    };
    store.dispatch(addPushWebToken(requestData)).then((res) => {
      // console.log("handle push notification", res);
    });
  };

  componentDidMount = () => {
    store.dispatch(getRoutes()).then((res) => {
      this.setState({ routemenu: res });
    });
    // store.dispatch(getPubRoutes()).then((res) => {
    //   // console.log(" route data = ",res);
    //   this.setState({ pubroutemenu: res })
    // });

    store.dispatch(getSetting()).then((res) => {
      // console.log('Footer data = ',res);
    });
  };

  render() {
    const routemenu = this.state.routemenu;
    // const basename = process.env.PUBLIC_URL || "/";
    const basename = "/";
    return (
      <ErrorBoundary>
        <Router basename={basename}>
          <Fragment>
            {/* <Notifications /> */}
            <CommonHeader />
            <Toaster />
            <Htmlhelmet />
            <Switch>
              <Route exact path={`/`}>
                <HomeLayout />
              </Route>

              {/* <Route path={`/login`}>
              <Login />
            </Route> */}
              {/* <Route path={`/login`}>
              <Login />
            </Route> */}
              <PublicRoute path={`/sample_login`} component={SampleLogin} />
              <Route path={`/profile`}>
                {/* <SampleLogin /> */}
                <Profile />
              </Route>
              {/* <Route path={`/access_level`}>
              <AccessLevel/>
            </Route> */}
              {/* <Route path={`/dashboard_admin`}>
              <DashboardDemo />
            </Route> */}
              <ProtectedRoute path="/dashboard_admin" component={DashboardDemo} />
              <Route path={`/signup`}>
                <SignupPolicy />
              </Route>
              <Route path={`/register`}>
                <Redirect to="/login-office" />
              </Route>
              <Route path={`/register-office`}>
                <RegisterOffice />
              </Route>
              <PublicRoute path={`/login-office`} component={LoginOffice} />
              <Route path={`/register-customer`}>
                <RegisterCustomer />
              </Route>
              <PublicRoute path={`/login-customer`} component={LoginCustomer} />
              <Route path={`/register-employee`}>
                <RegisterEmployee />
              </Route>
              <PublicRoute path={`/login-employee`} component={LoginEmployee} />
              <Route path={`/forgot-pass-new`}>
                <ForgotPasswordNew />
              </Route>
              <Route path={`/microsite-progress`}>
                <MicrositeProgress />
              </Route>

              <Route path={`/paydirect-step-1`}>
                <Paydirectstepone />
              </Route>
              <Route path={`/paydirect-step-2`}>
                <Paydirectsteptwo />
              </Route>
              <Route path={`/payment-step-1`}>
                <Paydirectstepthree />
              </Route>
              <Route path={`/payment-step-2`}>
                <Paydirectstepfour />
              </Route>

              <Route exact={true} path={`/dashboard`}>
                <Dashboard />
              </Route>
              <Route
                path={`/dashboard/policy-details/:id`}
              >
                <PolicyDetails />
              </Route>

              <Route path={`/dashboard/change-password`}>
                <ChangePassword />
              </Route>

              <Route
                path={`/dashboard/policyinvoice/:id`}
              >
                <PaymentInvoice />
              </Route>

              <Route path={`/page/:slug`}>
                <PageLayout />
              </Route>

              <Route path={`/product/:slug`}>
                <ProductDetails />
              </Route>

              <Route path={`/news/:slug`}>
                <NewsLayout />
              </Route>

              <Route path={`/search/:slug`}>
                <SearchLayout />
              </Route>

              <Route exact path={`/videos/:id/album`}>
                <VideoGallery />
              </Route>
              <Route exact path={`/photos/:id/album`}>
                <PhotoGallery />
              </Route>

              <Route exact path={`/forgot-password`}>
                <ForgotPassword />
              </Route>
              <Route exact path={`/reset-password`}>
                <ResetPassword />
              </Route>
              {/* <Route exact path={`/reset-password`}>
              <ResetPassword />
            </Route> */}
              {/* <Route exact path={`/policy-buy`}>
              <PolicyBuy />
            </Route> */}
              {/* <Route exact path={`/policy-buy`}>
              <PolicyBuy />
            </Route> */}
              <ProtectedRoute path="/policy-buy" component={PolicyBuy} />
              <Route
                exact
                path={`/policy-buy/preview/:transaction_id`}
              >
                <PolicyFormPreview />
              </Route>
              {/* <Route exact path="/policy-view/:policyId"> */}
              <Route exact path="/policy-view/:policyId">
                <PolicyFormPreview />
              </Route>
              <Route exact path="/policy-view-customer/:policyId">
                <PolicyFormPreviewCustomer />
              </Route>
              {/* Return Calculator */}
              <Route exact path={`/return-calculator`}>
                <ReturnCalculator />
              </Route>
              <Route exact path={`/login`}>
                <Redirect to="/login-office" />
              </Route>
              <Route exact path={`/policy-buy`}>
                <PolicyBuy />
              </Route>
              {routemenu.map((menu, index, { length }) => {
                if (menu.layout) {
                  //if(index + 1 === length) {
                  if (menu.layout.name.toLowerCase() == "home") {
                    return (
                      <Route
                        key={menu.id}
                        exact
                        path={`${menu.slug}`}
                        render={() => <HomeLayout />}
                      />
                    );
                  }
                  if (menu.layout.name.toLowerCase() == "policy buy") {
                    return (
                      <Route
                        key={menu.id}
                        exact
                        path={`${menu.slug}`}
                        render={() => <PolicyBuy />}
                      />
                    );
                  }
                  if (menu.layout.name.toLowerCase() == "common landing") {
                    return (
                      <Route
                        key={menu.id}
                        exact
                        path={`${menu.slug}`}
                        render={() => <CommonLanding />}
                      />
                    );
                  }
                  if (menu.layout.name.toLowerCase() == "gallery") {
                    return (
                      <Route
                        key={menu.id}
                        exact
                        path={`${menu.slug}`}
                        render={() => <CommonLanding />}
                      />
                    );
                  }
                  // if (menu.layout.name.toLowerCase() == 'contact us') {
                  //   return <Route key={menu.id} exact path={`${menu.slug}`} render={() => <Contactus />} />
                  // }
                  if (menu.layout.name.toLowerCase() == "premium calculator") {
                    return (
                      <Route
                        key={menu.id}
                        exact
                        path={`${menu.slug}`}
                        render={() => <PremiumCalculator />}
                      />
                    );
                  }
                  if (menu.layout.name.toLowerCase() == "branch") {
                    return (
                      <Route
                        key={menu.id}
                        exact
                        path={`${menu.slug}`}
                        render={() => <OfficeBranch />}
                      />
                    );
                  }

                  if (menu.layout.name.toLowerCase() == "member") {
                    // console.log(this.props);
                    return (
                      <Route
                        key={menu.id}
                        exact
                        path={`${menu.slug}`}
                        render={() => <Member />}
                      />
                    );
                  }
                } else {
                  return (
                    <Route
                      key={menu.id}
                      exact
                      path={`${menu.slug}`}
                      render={() => "404 NOT FOUND"}
                    />
                  );
                }
              })}
            </Switch>
            <Footer />
          </Fragment>
        </Router>
      </ErrorBoundary>
    );
  }
}

export default App;
